import { StringUtil } from "@mcleod/core";
import { Button, Component, PanelProps, ScreenStack, TableHeadingPanel } from "@mcleod/components";
import { AppTable } from "./AppTable";
import { FloatingActionButton } from "./FloatingActionButton";

export class AppTableHeadingPanel extends TableHeadingPanel {
    private _floatingActionButton: FloatingActionButton;

    constructor(table: AppTable, props?: Partial<PanelProps>) {
        super(table, props);
        this.table._element.appendChild(this.floatingActionButton._element);
        this.panelStandardLeftTools.buttonAdvancedSearch.get().setProps({ caption: "Advanced Search" });
        this.removeComponents();
        this.textboxSearch.setProps({ fillRow: true, rowBreak: true });
        this.labelRowCount.setProps({ rowBreak: true });
        this.textboxFilter.setProps({ fillRow: true });
    }

    private removeComponents() {
        this.remove(this.panelCustomLeftTools);
        this.remove(this.panelStandardLeftTools);
        this.remove(this.panelCustomCenterTools);
        this.remove(this.panelEllipsisActions);
        this.remove(this.hsToolSpacer);
        this.remove(this.panelCustomRightTools);
        this.remove(this.panelStandardRightTools);
    }

    get floatingActionButton(): FloatingActionButton {
        if (this._floatingActionButton == null) {
            this._floatingActionButton = new FloatingActionButton(this);
        }
        return this._floatingActionButton;
    }

    public doOnFabMount() {
        this.panelStandardRightTools.buttonAdd.syncCaption();
        this.floatingActionButton.syncActions();
        ScreenStack.pushMultiButton(this.floatingActionButton);
    }

    public doOnFabUnmount() {
        ScreenStack.popMultiButton(this.floatingActionButton);
    }

    get primaryAction(): Button {
        const customAction: Button = this.panelCustomRightTools.findComponentsByType(Button)?.[0];
        if (customAction != null) {
            return customAction;
        } else if (this.table.isNormalAddAllowed() ||
            (this.table.isQuickAddAllowed() && !StringUtil.isEmptyString(this.table.editLayout))) {
            return this.panelStandardRightTools.buttonAdd.get();
        }
        return null;
    }

    get secondaryActions(): Button[] {
        const condition = (component: Component) => {
            return component instanceof Button &&
                component != this.primaryAction &&
                component.visible &&
                component.enabled;
        }
        return this.gatherTools(condition) as Button[];
    }
}
